
import { DeliveryStage } from '@/types/delivery';

// Helper to get project type based on status
export const getProjectType = (status: DeliveryStage): string => {
  const typeMap: Record<string, string> = {
    'design': 'Design',
    'development': 'Web Development',
    'testing': 'Quality Assurance',
    'planning': 'Project Planning',
    'deployment': 'DevOps',
    'discovery': 'Research',
    'scoping': 'Requirements',
    'proposal': 'Business',
    'approval': 'Management',
    'review': 'Review',
    'training': 'Education',
    'support': 'Support',
    'backlog': 'Backlog',
    'in_progress': 'In Progress',
    'completed': 'Completed'
  };
  
  return typeMap[status] || 'General';
};

// Helper to determine priority based on status
export const getPriority = (status: DeliveryStage): 'low' | 'medium' | 'high' => {
  const highPriorityStatuses: DeliveryStage[] = ['in_progress', 'deployment', 'review'];
  const mediumPriorityStatuses: DeliveryStage[] = ['development', 'testing', 'design', 'planning'];
  
  if (highPriorityStatuses.includes(status)) {
    return 'high';
  } else if (mediumPriorityStatuses.includes(status)) {
    return 'medium';
  }
  return 'low';
};
